<div class="dialog-header">
  <h2 mat-dialog-title>{{ title() }}</h2>
  @if (subtitle()) {
    <p class="subtitle">{{ subtitle() }}</p>
  }
</div>

<mat-dialog-content class="dialog-body">
  <ng-content />
</mat-dialog-content>
